import type { BlockComponent } from '@blocksuite/affine/std';

const EDGELESS_ROOT = 'affine-edgeless-root';

/**
 * The open document's canvas, as soon as it stands in the page: at once while the canvas is shown,
 * otherwise when the editor has switched to it. Rejects when the signal aborts first.
 */
export function whenEdgelessRoot(signal: AbortSignal): Promise<BlockComponent> {
  return new Promise((resolve, reject) => {
    const find = () => document.querySelector<BlockComponent>(EDGELESS_ROOT);
    const ready = (root: BlockComponent) => {
      root.updateComplete.then(() => resolve(root)).catch(reject);
    };
    if (signal.aborted) return reject(signal.reason);
    const present = find();
    if (present) return ready(present);

    const onAbort = () => {
      observer.disconnect();
      reject(signal.reason);
    };
    const observer = new MutationObserver(() => {
      const root = find();
      if (!root) return;
      observer.disconnect();
      signal.removeEventListener('abort', onAbort);
      ready(root);
    });
    signal.addEventListener('abort', onAbort, { once: true });
    observer.observe(document.body, { childList: true, subtree: true });
  });
}
